import RootStore from './RootStore';
import { observable, action, makeObservable } from 'mobx';

export default class PreviewModalStore {
  private rootStore: RootStore;

  @observable isModalVisible: boolean = false;
  @observable currentAttachment: {
    fileName: string;
    fileId?: string;
    disabled: boolean;
  } = {
    fileName: '',
    fileId: undefined,
    disabled: true,
  };
  @observable isVisibleImage: boolean = false;
  @observable isError: boolean = false;

  @action
  setCurrentAttachment = (
    fileId: string,
    fileName: string,
    disabled: boolean,
  ) => {
    if (this.currentAttachment.fileId !== fileId) {
      this.isModalVisible = false;
    }
    this.currentAttachment = {
      fileName,
      fileId,
      disabled,
    };
  };

  @action
  hide = () => {
    this.isModalVisible = false;
  };

  @action
  show = () => {
    this.isModalVisible = true;
  };

  @action
  hideImage = () => {
    this.isVisibleImage = false;
  };

  @action
  showImage = () => {
    this.isVisibleImage = true;
  };

  @action
  setError = (isError: boolean) => {
    this.isError = isError;
  };

  @action
  toogle = () => {
    this.isModalVisible = !this.isModalVisible;
  };

  @action
  onClickAttachmentThumbnail = (fileId: string, fileName: string) => {
    this.setCurrentAttachment(fileId, fileName, false);
    this.show();
  };

  @action
  onClickClose = () => {
    this.hide();
  };

  @action
  onError = () => {
    this.hideImage();
    this.setError(true);
  };

  @action
  onLoad = () => {
    this.showImage();
    this.setError(false);
  };

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeObservable(this);
  }
}
